/**
 * Badge de status (online / degraded / offline).
 * Aceita a string direto ou um device para inferir.
 */
import { deviceStatus } from "../lib/format.js";

export default function StatusBadge({ status, device, withDot = true }) {
  const s = status ?? deviceStatus(device);
  if (s === "online") {
    return (
      <span className={`badge-ok ${withDot ? "pulse-dot" : ""}`}>online</span>
    );
  }
  if (s === "degraded") {
    return <span className="badge-warn">degradado</span>;
  }
  return <span className="badge-err">offline</span>;
}
